import { render, staticRenderFns } from "./ExpectedTransactions.vue?vue&type=template&id=de24aac4&scoped=true"
import script from "./ExpectedTransactions.vue?vue&type=script&lang=ts"
export * from "./ExpectedTransactions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de24aac4",
  null
  
)

export default component.exports